import { Root } from './ui/Root';
import { Card } from './ui/Card';
import { ContentWrapper } from './ui/ContentWrapper';
import { Header } from './ui/Header';
import { Parties } from './ui/Parties';
import { InfoList } from './ui/InfoList';
import { Rejected } from './ui/Rejected';

const EscrowDashboardCard = {
  Root,
  Card,
  ContentWrapper,
  Header,
  Parties,
  InfoList,
  Rejected,
};

export { EscrowDashboardCard };
export type { IEscrowDashboardItemViewModel, IEscrowDashboardCardConfig, IInfoListItem } from './model/types';
